import {
  CustomHeaderKey,
  ImportResultsRecord
} from '@components/bid_request/details/types';
import { CustomColumnItem, CustomColumnType } from 'types';
import { createDefaultDisplayTextForDataType } from '@components/bid_request/details/utils/createDefaultDisplayTextForDataType';

/**
 * Build custom items from row data
 * @param row {ImportResultsRecord}
 * @param customHeaderIndexes {CustomHeaderKey[]}
 * @param itemType
 */
export const buildCustomItems = (
  row: ImportResultsRecord,
  customHeaderIndexes: CustomHeaderKey[],
  itemType: CustomColumnType
): Partial<CustomColumnItem>[] => {
  const { $custom: custom = {}, $unmapped: unmapped = {} } = row;

  return customHeaderIndexes.map(header => ({
    column_type: itemType,
    custom_column_header_id: 'new',
    display_text: row[header.name]
        || unmapped[header.index]
        || custom[header.index]
        || createDefaultDisplayTextForDataType(header.dataType),
    is_supplier_visible: true,
    new_header_index: header.orderIndex
  })) as Partial<CustomColumnItem>[];
};
